<div class="outer">
    <div class="middle">
        <div class="inner">
            <div class="center-align logo-heading">
                <img src="assets/img/logo_dark.png" width="90%">
                <h1 class="zero-bottom-margin font-orrange margin-top-store">Asset Store</h1>
                <p class="sh-text sh-text--calibri sh-text--medium zero-top-margin p-margin-bottom color-white">Your
                    source for AR/VR Content</p>
            </div>
            <!-- <form #loginForm="ngForm">
                <div class="auto-margin" style="width: 18%;margin-bottom: 2em">
                    <br>
                    <div class="center-align" style="">
                    </div>
                    <br>
                </div>
            </form> -->
            <sh-spinner label="Logging..."></sh-spinner>
            <br>
            <div></div>
            <br>
        </div>
        <div class="center-align message-heading">
            <p class="sh-text sh-text--calibri zero-top-margin p-margin-bottom color-white message-padding">{{message}}</p>
        </div>
    </div>
</div>
<sh-modal id="termsModal" label='Terms and Conditions' modal-height='500px' hidden modal-width='500px'>
    <sh-text p class="text-align-left">
        <b class="text-align-center"> Please accept the following terms and conditions </b> <br /> <br />
        I’m aware that all Information from Siemens Healthineers that is within the VAL may be used both, internally and
        externally as well as globally and also commercially.
        <br><br>
        Therefore I agree,
        <br><br>
        to only upload data, pictures, video or any other information to the VAL, for which legal restrictions apply
        neither content wise, time wise, nor region wise regarding e.g. copy right, contractual agreements or
        arrangements of confidentiality. In case of doubt I verified this with LEGAL and/or DP.
        <br>
        to use all data, pictures, video or any other information I download from the VAL only within the framework of
        my terms of employment with Siemens Healthineers.
        <br>
    </sh-text>
    <sh-button color='tertiary' slot='footer' label='Cancel' (click)="declineTerms()"></sh-button>
    <sh-button color='secondary' slot='footer' label='Accept' (click)="acceptTerms()"></sh-button>
</sh-modal>